import TestimonyImageModelCommon from 'common/models/testimony-image';

export default class TestimonyImageModel extends TestimonyImageModelCommon {}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'testimony-image': TestimonyImageModel;
  }
}
